// Thin wrapper so tests can mock navigation: jsdom 26+ (Jest 30) makes `window.location` non-configurable.
export const assignLocation = (url: string): void => {
  window.location.assign(url);
};
